import { PageWrapper } from '../../../components/Layouts/PageWrapper';
import HeroSection from '../../../components/HeroSection';
import ActionCard from '../../../components/ActionCard';
import { HERO_CONTENT, ACTION_CARD_CONTENTS } from './constants';
import ContactForm from './components/ContactForm';
import { openSimplePracticeConsultation } from '../../../utils/simplePractice';

const ContactPage = () => {
  const handleContainedButtonClick = () => {
    openSimplePracticeConsultation();
  };

  const handleOutlinedButtonClick = () => {
    const contactForm = document.getElementById('contact-form-iframe');
    if (contactForm) {
      const top = contactForm.getBoundingClientRect().top + window.scrollY - 20;
      window.scrollTo({ top, behavior: 'smooth' });
    }
  };

  return (
    <PageWrapper>
      <HeroSection
        {...HERO_CONTENT}
        onContainedButtonClick={handleContainedButtonClick}
        onOutlinedButtonClick={handleOutlinedButtonClick}
      />
      <ActionCard {...ACTION_CARD_CONTENTS.CLIENT_PORTAL} direction="row" />
      <ContactForm />
    </PageWrapper>
  );
};

export default ContactPage;
